import React, { useContext, useState, useEffect } from 'react'
import { useAuth } from './auth.js'
import { getById, getTasksRewardingPoints, getUsersRewardingPoints } from '../server/server.js'

const UserContext = React.createContext()

const UserProvider = (props) => {
    const [rewardingPoints, setRewardingPoints] = useState({})
    const [availablePoints, setAvailablePoints] = useState(0)
    const [institution, setInstitution] = useState({})
    const [rewardingSystemEnabled, setRewardingSystemEnabled] = useState(false)
    const user = useAuth().data.user || JSON.parse(localStorage.getItem('user'))
    const setUser = useAuth().data.setUser

    useEffect(() => {
        if (!!user) {
            load_rewarding_points()
            loadUsersRewardingPoints()
            loadInstitution(user)
        }
    }, [user])

    const load_rewarding_points = async () => {
        const resp = await getTasksRewardingPoints()
        if (resp.status === 200) {
            const data = resp.data
            setRewardingPoints(data)
        }
    }

    const loadUsersRewardingPoints = async () => {
        const resp = await getUsersRewardingPoints()
        if (resp.status === 200) {
            const data = resp.data
            setAvailablePoints(data)
        }
    }

    const loadInstitution = async (user) => {
        const resp = await getById({
            collection: 'institutions',
            id: user?.institution_id,
        })
        if (resp.status === 200) {
            setRewardingSystemEnabled(!!resp.data?.rewardingSystem ? true : false)
            setInstitution(resp.data)
        }
    }

    const isSignedIn = !!user?.email || !!user?.id

    return (
        <UserContext.Provider
            value={{
                user,
                setUser,
                rewardingPoints,
                availablePoints,
                loadUsersRewardingPoints,
                rewardingSystemEnabled,
                institution,
                isSignedIn,
            }}
            {...props}
        />
    )
}

function useUser() {
    const context = useContext(UserContext)

    if (context === undefined) {
        throw new Error(`useUser must be used within a UserProvider`)
    }

    return context
}

export { UserProvider, useUser }
